import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'enumsV2';
import { useOutlookMode } from 'pages/outlook/outlook-compose-provider';

// The only pages where the print order feature lives. Note: exact pathnames on
// purpose — `/resources/favorites` (the Favorites page) and other subpaths are
// NOT print-order surfaces.
const PRINT_ORDER_PATHS: string[] = [ROUTES.HOME, ROUTES.RESOURCES];

/**
 * Whether the print order (shopping cart) feature is active in this context.
 *
 * On behind the `shoppingCart` LD flag, only on the Home and Resources pages,
 * and always off inside Outlook add-in dialogs. Everywhere else (Favorites,
 * My Files, embeds, …) the whole feature stays hidden: no "Add to Cart" in the
 * resource dropdown, no "In Cart" badge, no cart restore call, no floating
 * cart bar.
 */
/**
 * Whether this is a print-order company context at all: the `shoppingCart` LD
 * flag, and never inside Outlook add-in dialogs. Page-independent — used by the
 * resource preview dialog, which opens everywhere, not just on cart pages.
 */
export const usePrintOrderCompany = (): boolean => {
  const flags = useFlags();
  const isOutlookMode = useOutlookMode();

  return !!flags?.shoppingCart && !isOutlookMode;
};

export const usePrintOrderEnabled = (): boolean => {
  const isPrintOrderCompany = usePrintOrderCompany();
  const { pathname } = useLocation();

  // Normalize a possible trailing slash ("/resources/" → "/resources").
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  const isPrintOrderPage = PRINT_ORDER_PATHS.includes(normalizedPath);

  return isPrintOrderCompany && isPrintOrderPage;
};
